import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LandingLayout from '../components/LandingLayout';

export default function AffiliateProgramPage() {
  const { t } = useTranslation();

  return (
    <LandingLayout>
      <div className="min-h-screen bg-dark-950">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-primary-600/20 via-secondary-600/20 to-dark-950">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl md:text-6xl font-extrabold mb-6 text-white">
              {t('affiliate.hero.title')}
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              {t('affiliate.hero.subtitle')}
            </p>
            <Link
              to="/affiliate/apply"
              className="inline-block px-10 py-5 text-lg font-bold text-white bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-500 hover:to-orange-400 rounded-xl transition-all shadow-2xl hover:shadow-orange-500/50 hover:scale-105"
            >
              {t('affiliate.hero.cta')}
            </Link>
          </div>
        </section>

        {/* How It Works */}
        <section className="py-20 bg-dark-900">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl font-extrabold text-center mb-16 text-white">
              {t('affiliate.howItWorks.title')}
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[1, 2, 3].map((step) => (
                <div key={step} className="text-center p-8 bg-white/5 rounded-2xl border border-white/10">
                  <div className="text-6xl mb-6">{t(`affiliate.howItWorks.step${step}.icon`)}</div>
                  <h3 className="text-2xl font-bold mb-4 text-white">
                    {t(`affiliate.howItWorks.step${step}.title`)}
                  </h3>
                  <p className="text-gray-300">
                    {t(`affiliate.howItWorks.step${step}.description`)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Commission Structure */}
        <section className="py-20 bg-dark-950">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl font-extrabold text-center mb-16 text-white">
              {t('affiliate.commission.title')}
            </h2>
            <div className="bg-gradient-to-br from-primary-600/20 to-secondary-600/20 border border-white/20 rounded-3xl p-8 md:p-12">
              <div className="text-center mb-8">
                <div className="text-7xl font-extrabold bg-gradient-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent mb-4">
                  10%
                </div>
                <p className="text-2xl text-white font-semibold">
                  {t('affiliate.commission.rate')}
                </p>
              </div>
              <div className="space-y-4 text-gray-300">
                <p className="flex items-start">
                  <span className="text-2xl mr-3">✅</span>
                  <span>{t('affiliate.commission.benefit1')}</span>
                </p>
                <p className="flex items-start">
                  <span className="text-2xl mr-3">✅</span>
                  <span>{t('affiliate.commission.benefit2')}</span>
                </p>
                <p className="flex items-start">
                  <span className="text-2xl mr-3">✅</span>
                  <span>{t('affiliate.commission.benefit3')}</span>
                </p>
                <p className="flex items-start">
                  <span className="text-2xl mr-3">✅</span>
                  <span>{t('affiliate.commission.benefit4')}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Why Join */}
        <section className="py-20 bg-dark-900">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-4xl font-extrabold text-center mb-16 text-white">
              {t('affiliate.whyJoin.title')}
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="flex items-start space-x-4 p-6 bg-white/5 rounded-xl border border-white/10">
                  <div className="text-4xl flex-shrink-0">
                    {t(`affiliate.whyJoin.reason${item}.icon`)}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-white">
                      {t(`affiliate.whyJoin.reason${item}.title`)}
                    </h3>
                    <p className="text-gray-300">
                      {t(`affiliate.whyJoin.reason${item}.description`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-primary-600/20 via-secondary-600/20 to-dark-950">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl md:text-5xl font-extrabold mb-8 text-white">
              {t('affiliate.cta.title')}
            </h2>
            <p className="text-xl text-gray-300 mb-10">
              {t('affiliate.cta.subtitle')}
            </p>
            <Link
              to="/affiliate/apply"
              className="inline-block px-10 py-5 text-lg font-bold text-white bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-500 hover:to-orange-400 rounded-xl transition-all shadow-2xl hover:shadow-orange-500/50 hover:scale-105"
            >
              {t('affiliate.cta.button')}
            </Link>
          </div>
        </section>
      </div>
    </LandingLayout>
  );
}
